/** Saved inputs are immutable within one compile, including its yielded tasks.
 * A fresh scope prevents reuse after the caller edits a previously read object. */
const scopes = new WeakMap<object, Map<string, WeakMap<object, unknown>>>();
let active: object | undefined;

export function withFromBaseReadMemo<T>(scope: object, run: () => T): T {
    const previous = active; active = scope;
    try { return run(); } finally { active = previous; }
}

export function memoFromBaseRead<T>(source: object, kind: string, create: () => T): T {
    if (!active) return create();
    let scope = scopes.get(active);
    if (!scope) { scope = new Map(); scopes.set(active, scope); }
    // There are a few read kinds and many thousands of source nodes. One weak
    // index per kind avoids allocating a Map for every frozen JSON branch.
    let values = scope.get(kind);
    if (!values) { values = new WeakMap(); scope.set(kind, values); }
    if (!values.has(source)) values.set(source, create());
    return values.get(source) as T;
}
